import { render, staticRenderFns } from "./PostSroMainHomeStatus.vue?vue&type=template&id=633ab8be"
import script from "./PostSroMainHomeStatus.vue?vue&type=script&lang=js"
export * from "./PostSroMainHomeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports